import React from 'react';
import { Route } from 'react-router-dom';
import ApuracaoCaixa from './apuracao-caixa/ApuracaoCaixa';

import SwitchRouter from 'components/SwitchRouter';

export default function Routes({ match: { path } }) {
    const routes = [{ path: `${path}/apuracao-fechamento-caixa`, component: ApuracaoCaixa }];
    return (
        <SwitchRouter>
            {routes.map((props, i) => (
                <Route key={i} {...props} res/>
            ))}
        </SwitchRouter>
    );
}
